module.exports = __webpack_public_path__ + "42a340b94869b2bad73241b8beb4dd82.png";